import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

function ChevronDown(props: SvgIconProps) {
    return (
      <SvgIcon {...props}>
        <path id="outline" d="M11.8478 14.8292L8.18622 11.1676C7.85427 10.8356 7.85427 10.2975 8.18622 9.96551C8.51816 9.63357 9.05635 9.63357 9.3883 9.96551L12.4547 13.0319L15.5212 9.96551C15.8531 9.63357 16.3913 9.63357 16.7232 9.96551C17.0552 10.2975 17.0552 10.8356 16.7232 11.1676L13.0617 14.8292C12.8942 14.9967 12.6742 15.0796 12.4547 15.0781C12.2352 15.0796 12.0153 14.9966 11.8478 14.8292Z" fill="#182737" />
      </SvgIcon>
    );
  }
export { ChevronDown }